import template from 'text!./templates/default.html';

export default [function () {
    return {
        restrict: 'E',
        scope: { item: '&' },
        template: template
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/readonly-table/Default.js
// module id = 283
// module chunks = 0